import {staticDef} from './helpers.js';

try {
   if (!Object.setPrototypeOf) {
      Object.defineProperty(Array.prototype, 'find', staticDef(
         function (obj, proto) {
            obj.__proto__ = proto;
            return obj;
         }
      ));
   }

   if (!String.prototype.startsWith) {
      Object.defineProperty(String.prototype, 'startsWith', staticDef(
         function(search, rawPos) {
            var pos = rawPos > 0 ? rawPos|0 : 0;
            return this.substring(pos, pos + search.length) === search;
         }
      ));
   }

   if (!String.prototype.endsWith) {
      Object.defineProperty(String.prototype, 'endsWith', staticDef(
         function(search, this_len) {
            if (this_len === undefined || this_len > this.length) {
               this_len = this.length;
            }
            return this.substring(this_len - search.length, this_len) === search;
         }
      ));
   }

   (function(constructor) {
     if (constructor &&
         constructor.prototype &&
         constructor.prototype.childElementCount == null) {
       Object.defineProperty(constructor.prototype, 'childElementCount', staticDef({
         get: function() {
           var i = 0, count = 0, node, nodes = this.childNodes;
           while (node = nodes[i++]) {
             if (node.nodeType === 1) count++;
           }
           return count;
         }
       }));
     }
   })(window.Node || window.Element)

   if (!Array.prototype.reduce) {
      Object.defineProperty(Array.prototype, 'reduce', staticDef(
         function (callback /*, initialValue*/ ) {
            if (this === null) {
               throw new TypeError('Array.prototype.reduce ' +
                  'called on null or undefined');
            }
            if (typeof callback !== 'function') {
               throw new TypeError(callback +
                  ' is not a function');
            }

            // 1. Let O be ? ToObject(this value).
            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // Steps 3, 4, 5, 6, 7      
            var k = 0;
            var value;

            if (arguments.length >= 2) {
               value = arguments[1];
            } else {
               while (k < len && !(k in o)) {
                  k++;
               }

               // 3. If len is 0 and initialValue is not present,
               //    throw a TypeError exception.
               if (k >= len) {
                  throw new TypeError('Reduce of empty array ' +
                     'with no initial value');
               }
               value = o[k++];
            }

            // 8. Repeat, while k < len
            while (k < len) {
               // a. Let Pk be ! ToString(k).
               // b. Let kPresent be ? HasProperty(O, Pk).
               // c. If kPresent is true, then
               //    i.  Let kValue be ? Get(O, Pk).
               //    ii. Let accumulator be ? Call(
               //          callbackfn, undefined,
               //          « accumulator, kValue, k, O »).
               if (k in o) {
                  value = callback(value, o[k], k, o);
               }

               // d. Increase k by 1.      
               k++;
            }

            // 9. Return accumulator.
            return value;
         }
      ));
   }

   if (!Array.prototype.filter) {
      Object.defineProperty(Array.prototype, 'filter', staticDef(
         function (func, thisArg) {
            'use strict';
            if (!((typeof func === 'Function' || typeof func === 'function') && this))
               throw new TypeError();

            var len = this.length >>> 0,
               res = new Array(len), // preallocate array
               t = this,
               c = 0,
               i = -1;

            var kValue;
            if (thisArg === undefined) {
               while (++i !== len) {
                  // checks to see if the key was set
                  if (i in this) {
                     kValue = t[i]; // in case t is changed in callback
                     if (func(t[i], i, t)) {
                        res[c++] = kValue;
                     }
                  }
               }
            } else {
               while (++i !== len) {
                  // checks to see if the key was set
                  if (i in this) {
                     kValue = t[i];
                     if (func.call(thisArg, t[i], i, t)) {
                        res[c++] = kValue;
                     }
                  }
               }
            }

            res.length = c; // shrink down array to proper size
            return res;
         }
      ));
   }
   
   if (!Array.prototype.find) {
      Object.defineProperty(Array.prototype, 'find', staticDef(
         function (predicate) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
               throw TypeError('"this" is null or not defined');
            }

            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== 'function') {
               throw TypeError('predicate must be a function');
            }

            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            var thisArg = arguments[1];

            // 5. Let k be 0.
            var k = 0;

            // 6. Repeat, while k < len
            while (k < len) {
               // a. Let Pk be ! ToString(k).
               // b. Let kValue be ? Get(O, Pk).
               // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
               // d. If testResult is true, return kValue.
               var kValue = o[k];
               if (predicate.call(thisArg, kValue, k, o)) {
                  return kValue;
               }
               // e. Increase k by 1.
               k++;
            }

            // 7. Return undefined.
            return undefined;
         }
      ));
   }

   if (!Array.prototype.findIndex) {
      Object.defineProperty(Array.prototype, 'findIndex', staticDef(
         function(predicate) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
               throw TypeError('"this" is null or not defined');
            }

            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== 'function') {
               throw TypeError('predicate must be a function');
            }

            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            var thisArg = arguments[1];

            // 5. Let k be 0.
            var k = 0;

            // 6. Repeat, while k < len
            while (k < len) {
               // a. Let Pk be ! ToString(k).
               // b. Let kValue be ? Get(O, Pk).
               // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
               // d. If testResult is true, return kValue.
               var kValue = o[k];
               if (predicate.call(thisArg, kValue, k, o)) {
                  return k;
               }
               // e. Increase k by 1.
               k++;
            }

            // 7. Return undefined.
            return -1;
         }
      ));
   }

   if (!Array.prototype.includes) {
      Object.defineProperty(Array.prototype, 'includes', staticDef(
         function(value) {
            return this.indexOf(value) != -1;
         }
      ));
   }

   if (typeof Object.values !== 'function') {
      Object.defineProperty(Object, 'values', staticDef(
         function(obj) {
            return Object.keys(obj).map(function(e) {
               return obj[e]
            });
         }
      ));
   }

   if (typeof Object.assign !== 'function') {
     // Must be writable: true, enumerable: false, configurable: true
     Object.defineProperty(Object, "assign", {
       value: function assign(target, varArgs) { // .length of function is 2
         'use strict';
         if (target === null || target === undefined) {
           throw new TypeError('Cannot convert undefined or null to object');
         }

         var to = Object(target);

         for (var index = 1; index < arguments.length; index++) {
           var nextSource = arguments[index];

           if (nextSource !== null && nextSource !== undefined) {
             for (var nextKey in nextSource) {
               // Avoid bugs when hasOwnProperty is shadowed
               if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                 to[nextKey] = nextSource[nextKey];
               }
             }
           }
         }
         return to;
       },
       writable: true,
       configurable: true
     });
   }
   
   Number.isNaN = Number.isNaN || function isNaN(input) {
      return typeof input === 'number' && input !== input;
   }
   Number.isInteger = Number.isInteger || function isInteger(input) {
      return typeof input !== 'object' && isFinite(input) && Math.floor(input) === input;
   }
} catch(e) {
   // Ignore and prevent IE8 errors
}

